module.exports = __webpack_public_path__ + "static/media/previewIcon.7b3d31b9.svg";